import type { BasedFunctionConfig } from '@based/sdk/functions'

export default {
  type: 'query',
  name: 'list-noteworty-initiative',
  public: false,
} as BasedFunctionConfig
